<template>
  <div id="app">
    <v-app dark>
      <v-navigation-drawer fixed clipped v-model="drawer" app>
        <v-list dense>
          <v-list-tile :to="{path: '/'}">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Home</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="authenticated" :to="{path: '/alertsreport'}">
            <v-list-tile-action>
              <v-icon>library_books</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Alerts Report</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="authenticated" :to="{path: '/latestposts'}">
            <v-list-tile-action>
              <v-icon>whatshot</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Latest</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="isApp" @click="toggleMe">
            <v-list-tile-action>
              <v-icon>system_update</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>IQ System Update</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar dark color="primary" dense fixed clipped-left app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="white--text">Volturnus AutoWash Analytics System</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn> -->
        <v-btn v-if="false" icon @click="toggleMe">
          <v-icon>cloud_upload</v-icon>
        </v-btn>
        <v-btn icon :to="{path: '/help'}">
          <v-icon>help_outline</v-icon>
        </v-btn>
        <v-btn flat v-if="!authenticated" @click="login()">Sign In</v-btn>
        <v-btn icon v-if="authenticated" @click="logout()">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
        <!-- <v-btn icon>
          <v-icon>refresh</v-icon>
        </v-btn> -->
        <!-- <v-btn icon>
          <v-icon>more_vert</v-icon>
        </v-btn> -->
      </v-toolbar>
      <v-content>
        <v-container fluid>
          <!-- <img src="./assets/hero.jpeg"> -->
          <router-view :auth="auth" :authenticated="authenticated">
          </router-view>
        </v-container>
      </v-content>
      <!-- <button
        class="btn btn-primary btn-margin"
        v-if="!authenticated"
        @click="login()">
          Log In
      </button>

      <button
        class="btn btn-primary btn-margin"
        v-if="authenticated"
        @click="logout()">
          Log Out
      </button>
      
      <router-view 
        :auth="auth" 
        :authenticated="authenticated">
      </router-view> -->
    </v-app>
  </div>
</template>

<script>
import AuthService from './auth/AuthService';
//import firebase from './firebase';
const auth = new AuthService();

const { login, logout, authenticated, authNotifier } = auth;

export default {
  name: 'App',
  data() {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated;
      auth.setRoles();
      this.$store.dispatch('authFirebase');
    });
    return {
      auth,
      authenticated,
      drawer: false
    };
  },
  computed: {
    isTrue: function() {
      return this.$store.getters.isTrue;
    },
    isApp() {
      return this.$store.getters.isApp;
    }
  },
  methods: {
    login,
    logout,
    toggleMe: function() {
      //this.$store.dispatch('toggle');
      //this.$store.dispatch('togglefs');
      //this.$store.dispatch('load_comments');
      window.location.assign('http://command.html?cmdName=scan');
    }
  },
  created: function() {
    this.$store.dispatch('getFirebaseData').then(() => {
      this.auth.setRoles();
    });
  }
};
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue